import React, {useContext, useState, useEffect} from 'react';
import { Context } from '../contextApi/context';
import desk from './assets/desk.svg';
import './OrgLanding.css';
import NewOrganizationPopup from './NewOrganizationPopup';
import UserService from '../services/UserService';
import axios from 'axios';

const serverConfig = require("./../config/server.js");

const OrgLanding = () => {
    const {collapse, setRefreshOrgList, refreshOrgList} = useContext(Context);
    const [newOrganizationPopup, setNewOrganizationPopup] = useState(false);
    const[close, setClose]= useState(false);
    const [token, setToken] = useState(null);

    const [alertMessage, setAlertMessage] = useState("");
    const [showOkButton, setShowOkButton] = useState(false);
    const [alertModalShow, setAlertModalShow] = useState(false);
    const handleCloseAlertModal = () => {
      setAlertMessage("");
      setShowOkButton(false);
      setAlertModalShow(false);
    }
    const handleShowAlertModal = (alert_msg, show_ok_button) => {
      setAlertMessage(alert_msg);
      setShowOkButton(show_ok_button);
      setAlertModalShow(true);
    }

    const handleLogout = () => {
        sessionStorage.clear();
        window.history.replaceState( {} , '', '/' );
        navigate("/");
        UserService.doLogout();
      }

    const getToken = () => {
        console.log(sessionStorage.getItem('token'));
        let jwt = UserService.getToken();
        axios.post(serverConfig.api_base_url + "user_get_token_no_auth",{jwt:jwt, url:window.location.host})
        .then(response=>{
          console.log('user_get_token_no_auth response', response);
          if(response.data.status === 200){
            if(organizationList.length > 0){
                navigate("/users");
              }
              else {
                navigate("/members");
              }
            sessionStorage.setItem('token', response.data.token);
            //menuListGet(response.data.token);
            setToken(response.data.token);
          } else if(response.data.status >= 400 && response.data.status <= 499){
            alert(response.data.message);
          } else if(response.data.jwt_validation === 'fail') {
            handleLogout();
          }
        })
        .catch(err=>console.log("error is",err));
      }
    
      useEffect(() => {
        console.log(sessionStorage.getItem('token'));
        if(sessionStorage.getItem('token') === null){
          getToken();
        } else {
          setToken(sessionStorage.getItem('token'));
          //menuListGet(sessionStorage.getItem('token'));
        }
      }, []);


    return (
        <>
        {close===false ?
        <>
        <div className={collapse?'banner p-2 pl-4 rounded-xl relative':'banner-collapse p-2 pl-4 rounded-xl relative'}>
        <div className='flex justify-between px-4 gap-10 py-2' style={{alignItems:'center'}}>
            <div className='md:mr-10 '>
            <div className='txt-title'>Add your Organisation</div>
            <div className='text-sm text-white mt-3'> We notice that you haven’t added any organisation.
             <br/> Add an organisation so that you can invite your colleagues and collaborate together.</div>
            <button type="submit" onClick={()=> {setNewOrganizationPopup(true);}} className='btn-popup px-4 py-2 rounded-lg mt-6 text-sm text-medium'>Create Organization</button>
            </div>
            <div className='mx-10'>
            <img src={desk} alt='Banner'/>
            </div>

        </div>
        {/* <button className='absolute right-4 top-2' onClick={()=>{setClose(true)}}>
        <i class="fa-solid fa-xmark"></i>
        </button> */}

        {newOrganizationPopup &&<div className='overlay'> <NewOrganizationPopup handleCloseAlertModal={handleCloseAlertModal} handleShowAlertModal={handleShowAlertModal} setNewOrganizationPopup={setNewOrganizationPopup} token={token} handleLogout={handleLogout}/></div>}
            </div>
            </> : <></> }


        {/* <div className={collapse?'content-body':'content-body-collapse'} >      
            <div class="container-fluid">
            <div className='first-org'>
            <h1>Welcome to KEZEL!</h1>
            <h3>Get started by creating your first organization</h3>
            <button type="submit" onClick={()=> {setNewOrganizationPopup(true);}} className='btn-popup px-4 py-2 rounded-lg mt-2 text-sm text-medium'>Create Organization</button>
            </div>
            </div>
        </div>
        {newOrganizationPopup &&<div className='overlay'> <NewOrganizationPopup setNewOrganizationPopup={setNewOrganizationPopup} token={token} handleLogout={handleLogout}/></div>} */}
        </>
    )
}

export default OrgLanding;